import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { TemperatureControlListPage, ListEquipmentsPage } from 'pages/TemperatureControl';
import {
  BASE_TEMPERATURE_CONTROL_PATH,
  TEMPERATURE_CONTROL_ROUTES,
} from 'lib/routes';

export const temperatureControlRoutes = ({
                                           location,
                                           isLoggedIn,
                                           hasPermissionTo,
                                         }: RouterProps): RouteObject => {
    const Fallback = <Navigate to={'/'} state={{ from: location }} />;

    return {
      path: BASE_TEMPERATURE_CONTROL_PATH,
      element: isLoggedIn
        ? <Outlet /> : Fallback,
      children: [
        {
          path: TEMPERATURE_CONTROL_ROUTES.list().path,
          element: hasPermissionTo(TEMPERATURE_CONTROL_ROUTES.list().permissions)
            ? <TemperatureControlListPage /> : Fallback,
        },
        {
          path: TEMPERATURE_CONTROL_ROUTES.listEquipments().path,
          element: hasPermissionTo(TEMPERATURE_CONTROL_ROUTES.listEquipments().permissions)
            ? <ListEquipmentsPage /> : Fallback,
        },
      ],
    };
  }
;
